import { render, staticRenderFns } from "./externalLinks.vue?vue&type=template&id=014e21a0&scoped=true"
import script from "./externalLinks.vue?vue&type=script&lang=js"
export * from "./externalLinks.vue?vue&type=script&lang=js"
import style0 from "./externalLinks.vue?vue&type=style&index=0&id=014e21a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014e21a0",
  null
  
)

export default component.exports